import React from "react";
import { Link } from "react-router-dom";
import { Layout, Menu } from "antd";
import {
  HomeOutlined,
  BarChartOutlined,
  PieChartOutlined,
  LineChartOutlined,
  DollarCircleOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";

const { Header } = Layout;

const Navbar = () => {
  return (
    <Header
      style={{
        background: "#ffff",
        zIndex: 1000,
        padding: "0 24px",
        position: "sticky",
        top: 0,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Link to="/" style={{ marginRight: "auto", display: "flex", alignItems: "center" }}>
        <div style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#1a1a1a",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}>
          mf.ai
        </div>
      </Link>
      <Menu
        mode="horizontal"
        defaultSelectedKeys={["1"]}
        style={{ flex: 1, justifyContent: "center", border: "none" }}
      >
        <Menu.Item key="1" icon={<HomeOutlined />}>
          <Link to="/">Home</Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<LineChartOutlined />}>
          <Link to="/insights">Insights</Link>
        </Menu.Item>
        <Menu.Item key="3" icon={<BarChartOutlined />}>
          <Link to="/sectors">Sectors</Link>
        </Menu.Item>
        {/* <Menu.Item key="4" icon={<DollarCircleOutlined />}>
          Stocks
          <Link to="/stocks" />
        </Menu.Item> */}
        <Menu.Item key="5" icon={<AppstoreOutlined />}>
          <Link to="/portfolio-overlap">Portfolio Overlap</Link>
        </Menu.Item>
      </Menu>
    </Header>

    // <nav className="navbar">
    //   <Link to="/">Home</Link>
    //   <Link to="/insights">Insights</Link>
    //   <Link to="/sectors">Sectors</Link>
    //   <Link to="/fund">Stocks</Link>
    // </nav>
  );
};

export default Navbar;
